import classNames from 'classnames';

type Spacing = 'none' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl';
type AsElement = 'div' | 'form' | 'section';

type ElementProps<T extends AsElement> = T extends 'form'
    ? React.FormHTMLAttributes<HTMLFormElement>
    : T extends 'section'
      ? React.HTMLAttributes<HTMLElement>
      : React.HTMLAttributes<HTMLDivElement>;

type VerticalContainerProps<T extends AsElement = 'div'> = {
    as?: T;
    children: React.ReactNode;
    spacing?: Spacing;
    className?: string;
    style?: React.CSSProperties;
} & ElementProps<T>;

const spacingMap: Record<Spacing, string> = {
    none: '',
    sm: 'gap-2',
    md: 'gap-4',
    lg: 'gap-6',
    xl: 'gap-8',
    xxl: 'gap-10',
    xxxl: 'gap-12',
};

export const VerticalContainer = <T extends AsElement = 'div'>({
    as,
    children,
    spacing = 'md',
    className,
    style,
    ...rest
}: VerticalContainerProps<T>) => {
    const Component = (as || 'div') as any;

    return (
        <Component
            className={classNames(
                'flex flex-col',
                spacingMap[spacing],
                className,
            )}
            style={style}
            {...rest}
        >
            {children}
        </Component>
    );
};
